import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../app/store";

interface RLRestState {
  data: {} | any | null;
  totalPages: number | null;
}

const initialState: RLRestState = {
  data: null,
  totalPages: null,
};

export const RLRestSlice = createSlice({
  name: "RLRest",
  initialState,
  reducers: {
    setRLRest: (state, action) => {
      state.data = action.payload;
      state.totalPages = action.payload.totalPages;
    },
    resetRLRest: (state) => {
      state = initialState;
    },
  },
});

export const { setRLRest, resetRLRest } = RLRestSlice.actions;

export const getBlogsData = (state: RootState) => state.RLRest.data;
export const getBlogTotalPages = (state: RootState) => state.RLRest.totalPages;

export default RLRestSlice.reducer;
